import { Tabs } from "client/CommonComponents"
import AssetFleetProcessingBreadcrumb from "../AssetFleetProcessing/AssetFleetProcessingBreadcrumb"
import AssetOrderDetailView from "../Asset/AssetOrderDetailView";
import AssetFleetProcessing from "../AssetFleetProcessing";
import AssetOrderDetailViewBreadcrumb from "../Asset/AssetOrderDetailView/AssetOrderDetailViewBreadcrumb";
import ApprovalHistory from "../ApprovalHistory";

const AssetFleetProcessingMainContainer = (props:any) => {
    const { tab, setSelectedKey, tabSwitchClicked, setTabSwitchClicked } = props
    const tabItems = [
        {
          itemKey: "requisition",
          headerText: "Order Details",
            content: <AssetOrderDetailView
                setSelectedKey={setSelectedKey}
                tab={tab}
                tabSwitchClicked={tabSwitchClicked}
                setTabSwitchClicked={setTabSwitchClicked}
            />
        },
        {
            itemKey: "approvalHistory",
            headerText: "Approval History",
            content:   <ApprovalHistory 
            setSelectedKey={props.setSelectedKey} 
            tab={tab}
            tabSwitchClicked={props.tabSwitchClicked}
            setTabSwitchClicked={props.setTabSwitchClicked}
            />
          },
        {
          itemKey: "fleet-processing",
          headerText: "Fleet Processing",
          content: <AssetFleetProcessing
          selectedKey={props?.selectedKey}    
          setSelectedKey={setSelectedKey}
          tabSwitchClicked={tabSwitchClicked}
          setTabSwitchClicked={setTabSwitchClicked}
          setShowFleetBreadcrumb={props.setShowFleetBreadcrumb}
          tab={tab}
          />
        }
    ];
    return(
        <div className="fleetProcessing fleet-processing-asset mt-3 mt-md-0" ref={props.wrapperRef}>
            { !props?.showFleetBreadcrumb ? <AssetOrderDetailViewBreadcrumb/> : <AssetFleetProcessingBreadcrumb/>}
            <Tabs
                className={`custom-tab `}
                tabItems={tabItems}
                selectedKey={props?.selectedKey}
                handleLinkClick={props?.handleLinkClick}
             data-attribute="AssetFleetProcessingMainContainer_Default_Tabs" /> 
        </div>
    )
}

export default AssetFleetProcessingMainContainer